import axios from 'axios';
import { Configuration } from '../models/configuration';
import { ProposalMatch } from '../models/proposalmatch';
import { User } from '../models/user';

class ConfigurationWebservice {

    /**
     * Call the login method on api
     *
     * @param email Email address
     * @param configuration Configuration
     */
    public sendConfiguration(user: User,
                             followUp: boolean,
                             comment: string,
                             configuration: Configuration,
                             proposalMatches: ProposalMatch[]) {
        return axios.post('/configurations/store', {
            user,
            followUp,
            comment,
            configuration,
            proposalMatches,
        });
    }
}

export const configurationWebservice = new ConfigurationWebservice();
